import { styled } from "@mui/material/styles";

export const TextEllipsis = styled("div")`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
